import { NEW_RELIC_SCRIPT } from './types';
export default {
  [NEW_RELIC_SCRIPT]: state => state.newRelicScript
};